"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStack = useStack;
exports.STATES = void 0;

var _react = require("react");

var _dateFns = require("date-fns");

const STATES = {
  LOADING: 'loading',
  DELETING: 'deleting',
  READY: 'ready'
};
exports.STATES = STATES;

function useStack() {
  const [stack, updateStack] = (0, _react.useState)([]);
  const incrementalId = (0, _react.useRef)(0);
  const closeCallbacksEventBus = (0, _react.useRef)([]);
  const removeRef = (0, _react.useRef)();

  const update = (id, newOptions) => {
    updateStack(newStack => newStack.map(item => item.id === id ? { ...item,
      ...newOptions,
      id
    } : item));
  };

  const remove = id => {
    updateStack(newStack => newStack.filter(item => {
      if (item.id !== id) {
        return true;
      }

      if (item.onClose) {
        closeCallbacksEventBus.current.push(item.onClose);
      }

      return false;
    }));
  };

  const flagToRemove = id => {
    const toast = stack.find(t => t.id === id);

    if (!toast || toast.removing) {
      return;
    }

    update(id, {
      state: STATES.DELETING
    });
    setTimeout(() => remove(id), 1000);
  };

  removeRef.current = flagToRemove;
  // This use effect executes all close callback after the component update
  // ---- (close action) ----
  //                     ---- (component life cycle) ----
  //                                                 ---- (close callback) ----
  (0, _react.useEffect)(() => {
    closeCallbacksEventBus.current = closeCallbacksEventBus.current.filter(callback => {
      callback();
      return false;
    });
    return () => {
      stack.forEach(toast => {
        clearTimeout(toast.timeout);
      });
    };
  });
  return {
    stack,
    push: (message, options = {}) => {
      const {
        level = 'info',
        delay = 5000,
        ...rest
      } = options;
      const id = ++incrementalId.current;
      updateStack(newStack => [...newStack, {
        id,
        level,
        message,
        delay,
        state: delay > 0 ? STATES.LOADING : STATES.READY,
        ...rest,
        timeLeft: delay,
        startedAt: new Date(),
        timeout: delay > 0 ? setTimeout(() => removeRef.current(id), delay) : null
      }]);
    },
    update,
    remove: flagToRemove,
    pause: id => {
      const toast = stack.find(t => t.id === id);

      if (toast.delay === -1) {
        return;
      }

      update(id, {
        state: toast.state === STATES.DELETING ? toast.state : STATES.READY,
        timeLeft: toast.timeLeft - (0, _dateFns.differenceInMilliseconds)(new Date(), toast.startedAt)
      });
      clearTimeout(toast.timeout);
    },
    resume: id => {
      const toast = stack.find(t => t.id === id);
      let newState = toast.state;

      if (toast.delay === -1) {
        return;
      }

      if (toast.state !== STATES.DELETING) {
        newState = toast.timeLeft > 0 ? STATES.LOADING : STATES.READY;
      }

      update(id, {
        startedAt: new Date(),
        timeout: setTimeout(() => {
          removeRef.current(id);
        }, toast.timeLeft),
        state: newState
      });
    }
  };
}